document.addEventListener('DOMContentLoaded', function () {
  const endpoint =
    'https://script.google.com/macros/s/AKfycbw50OWOOEdMnCvSOQGWN0SWNkeddDTNujjKW8N1-kqwYoFtnv1_nanjGhWFpMPEHX-Lmg/exec';

  function animateCount(el, target, duration = 650) {
    const currentText = (el.textContent || '').trim();
    const hasNumber = /\d/.test(currentText);
    const startValue = hasNumber ? parseInt(currentText.replace(/[^\d]/g, ''), 10) || 0 : 0;
    const endValue = Number(target) || 0;

    if (startValue === endValue && hasNumber) {
      el.textContent = endValue;
      return;
    }

    const startTime = performance.now();

    function step(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const currentValue = Math.round(startValue + (endValue - startValue) * eased);

      el.textContent = currentValue;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = endValue;
      }
    }

    requestAnimationFrame(step);
  }

  function animateWidth(el, targetPercent, duration = 700) {
    const currentWidth = parseFloat(el.style.width) || 0;
    const endWidth = Number(targetPercent) || 0;

    if (currentWidth === endWidth) {
      el.style.width = endWidth + '%';
      return;
    }

    const startTime = performance.now();

    function step(now) {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const currentWidthValue = currentWidth + (endWidth - currentWidth) * eased;

      el.style.width = currentWidthValue + '%';

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.style.width = endWidth + '%';
      }
    }

    requestAnimationFrame(step);
  }

  function updateRunCard(runNumber, runData) {
    const titleEl = document.getElementById(`exchange-board-run-${runNumber}-title`);
    const textEl = document.getElementById(`exchange-board-run-${runNumber}-text`);
    const fillEl = document.getElementById(`exchange-board-run-${runNumber}-fill`);

    if (!titleEl || !textEl || !fillEl) return;

    if (!runData) {
      titleEl.textContent = 'No active run';
      textEl.textContent = 'Awaiting procurement signals';
      animateWidth(fillEl, 0);
      return;
    }

    titleEl.textContent = runData.title || 'Procurement Run';
    textEl.textContent = runData.progress_text || 'Awaiting procurement signals';
    animateWidth(fillEl, runData.percent ?? 0);
  }

  async function updateExchangeBoardMetrics() {
    try {
      const response = await fetch(endpoint, {
        method: 'GET',
        cache: 'no-store'
      });

      const data = await response.json();

      if (!data || !data.ok || !data.metrics) {
        console.log('Exchange Board metrics response invalid:', data);
        return;
      }

      const metricValues = document.querySelectorAll('.exchange-board__metric-value');

      if (metricValues.length >= 4) {
        animateCount(metricValues[0], data.metrics.active_signals ?? 0);
        animateCount(metricValues[1], data.metrics.procurement_runs ?? 0);
        animateCount(metricValues[2], data.metrics.verification_requests ?? 0);
        animateCount(metricValues[3], data.metrics.participating_suppliers ?? 0);
      }

      const updatedEl = document.querySelector('.exchange-board__updated');

      if (updatedEl && data.last_updated) {
        const date = new Date(data.last_updated);

        const formatted = date.toLocaleString('en-PH', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        });

        updatedEl.textContent = 'Updated ' + formatted;
      }

      const runs = Array.isArray(data.runs) ? data.runs : [];
      updateRunCard(1, runs[0] || null);
      updateRunCard(2, runs[1] || null);
    } catch (error) {
      console.log('Exchange Board live metrics error:', error);
    }
  }

  updateExchangeBoardMetrics();

  setInterval(updateExchangeBoardMetrics, 120000);
});


/* =========================================
   Exchange Board Live Pulse
   ========================================= */

function updateBoardTimestamp() {
  const el = document.querySelector('.exchange-board__updated');
  if (!el) return;

  const now = new Date();
  const time = now.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});
  el.textContent = "Updated today · " + time;
}

function pulseRunBars() {
  document.querySelectorAll('.exchange-board__run-fill').forEach(bar => {
    const current = parseInt(bar.style.width);
    const jitter = Math.floor(Math.random() * 2);
    const next = Math.min(current + jitter, 100);
    bar.style.width = next + "%";
  });
}

function pulseMetrics() {
  document.querySelectorAll('.exchange-board__metric-value').forEach(metric => {
    if (metric.textContent === "-") return;

    const base = parseInt(metric.textContent.replace(/[^\d]/g,'')) || 0;
    const change = Math.floor(Math.random()*2);
    metric.textContent = base + change;
  });
}

function exchangeBoardPulse(){
  updateBoardTimestamp();
  pulseRunBars();
  pulseMetrics();
}

/* run immediately */
exchangeBoardPulse();

/* run every minute */
setInterval(exchangeBoardPulse, 60000);